// Company: Ajinsoft
// Author: Uilan Coqueiro
// Date: 2023-03-30

import { AppService } from '@ajin/services/app.service';
import { Component, EventEmitter, Output, ViewEncapsulation, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'ajin-button-footer',
    templateUrl: './button.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ButtonFooterComponent),
            multi: true
        }
    ]
})

export class ButtonFooterComponent {
    @Output() readonly click: EventEmitter<void> = new EventEmitter<void>();
    constructor(
        public app: AppService) { }
}
